import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Alert from '../../../../../components/global/Alert';
import Button from '../../../../../components/global/Button';
import Spinner from '../../../../../components/global/Spinner';
import PinField from '../../../../../components/global/PinField';

const propTypes = {
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  isFormValid: PropTypes.bool,
  onResendEmail: PropTypes.func.isRequired,
};

const AuthModeEmailPin = ({
  onSubmit,
  values,
  onChange,
  error,
  loading,
  isFormValid,
  onResendEmail,
}) => {
  const isValid = values.pinCode?.length === 4;

  return (
    <Fragment>
      <form className="login-form" onSubmit={onSubmit}>
        <p className="text-center">Insert your email PIN code below:</p>
        <div className="mb-2">
          <PinField
            className="registration-pin-field registration-pin-input m-auto"
            onComplete={value => {
              onChange('pinCode', value);
            }}
            onChange={value => {
              onChange('pinCode', value);
            }}
          />
        </div>

        <div className="text-center text-light">
          Didn&rsquo;t receive the email?{' '}
          <Button onClick={onResendEmail} btnStyle="link" className="text-bold">
            Resend email
          </Button>
        </div>

        {error && (
          <Alert type="danger" className="mt-2">
            <strong>Signing in wasn&apos;t successful</strong>
            <br />
            {error}
          </Alert>
        )}
        <div className="text-center">
          <Button
            type="submit"
            className="mt-4 mb-1 login-email-form-button"
            disabled={loading || !isFormValid || !isValid}
            data-testId="sign-in-button"
          >
            {!loading ? 'Log in' : <Spinner light size="xs" />}
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

AuthModeEmailPin.propTypes = propTypes;

export default AuthModeEmailPin;
